import { ErrorMessage } from '@hookform/error-message'
import get from 'lodash/get'
import React from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'
import { FormFeedback, FormGroup, Input, InputProps, Label } from 'reactstrap'
import { AddonSettings, InputAddon } from 'src/components/molecules/InputAddon'
import BadgeMiddle from './BadgeMiddle'

type Props = {
  id: string
  name: string
  type: string
  requiredText?: string
  isAnyInput?: boolean
  label?: string
  placeholder?: string
  validate?: RegisterOptions['validate']
  annotation?: string
  addonSettings?: AddonSettings
} & InputProps

type RBRef = string & ((ref: Element | null) => void)

export const FieldInput: React.FC<Props> = ({
  name,
  label,
  requiredText,
  isAnyInput,
  id,
  type,
  validate,
  children,
  annotation,
  addonSettings,
  ...others
}) => {
  const {
    register,
    errors,
    formState: { touched }
  } = useFormContext()
  const isTouched = touched && get(touched, name)
  const isError = get(errors, name)

  return (
    <FormGroup className={`${isTouched && isError ? 'text-danger' : ''} ${type === 'hidden' ? 'mb-0 d-none' : ''}`}>
      {label && (
        <Label for={id}>
          {label} {requiredText && <BadgeMiddle color="danger">必須</BadgeMiddle>}
          {!requiredText && isAnyInput && <BadgeMiddle color="info">任意</BadgeMiddle>}
        </Label>
      )}
      {annotation && <small className={'d-inline-block ml-2'}>{annotation}</small>}
      <div className="input-group">
        {addonSettings?.addonType === 'prepend' && <InputAddon {...{ ...addonSettings }} />}
        <Input
          {...{ name, id, type, ...others }}
          innerRef={
            register({
              required: requiredText,
              validate
            }) as RBRef
          }
          valid={Boolean(isTouched && !isError)}
          invalid={Boolean(isTouched && isError)}
        >
          {children}
        </Input>
        {addonSettings?.addonType === 'append' && <InputAddon {...{ ...addonSettings }} />}
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <FormFeedback invalid={'true'}>{message}</FormFeedback>}
        />
      </div>
    </FormGroup>
  )
}
